<button type="button" class="btn-count relative" [attr.aria-label]="ariaLabel()" [title]="title()">
  <rma-icon [glyph]="matIcon()" />

  @if (count()) {
    @for (value of [count()]; track value) {
      <!-- The top padding pays back the font descent: items-center centres the line box, which a digit fills only to the ascent. -->
      <span
        class="absolute top-1 right-0.5 flex h-[0.8rem] min-w-[0.8rem] items-center justify-center rounded-full bg-blue-50 px-0.5 pt-[0.125rem] text-[0.5rem] leading-none font-bold text-white"
        [animate.enter]="badgeAnimation()"
        aria-hidden="true"
      >
        {{ value }}
      </span>
    }
  }
</button>
